<template>
    <div class="clock">
      <label class="hour">{{ $date(currentTime).format('HH') }}</label>
      <label class="ticker">:</label>
      <label class="minutes">{{ $date(currentTime).format('mm') }}</label>
    </div>
  </template>
  
  <script>
      /*import { useDate } from 'vue3-dayjs-plugin/useDate';
      import { ref, onBeforeUnmount } from 'vue';
      const currentTime = ref(new Date());
      const updateCurrentTime = () => {
          currentTime.value = new Date();
      };
  
      const updateTimeInterval = setInterval(updateCurrentTime, 1000);
  
      onBeforeUnmount(() => {
          clearInterval(updateTimeInterval);
      });*/

    export default {
        name: 'Clock',
        data () {
            return {
                updateTimeInterval: null,
                currentTime: null
            }
        },
        mounted () {
            this.currentTime = new Date();
            const updateCurrentTime = () => {
                this.currentTime = new Date();
            };
            this.updateTimeInterval = setInterval(updateCurrentTime, 1000);
        },
        unmounted () {
            clearInterval(this.updateTimeInterval);
        },
        methods: {
            
        }
    };
  </script>
  
  <style lang="less">
  @import '../theme/variables';

  .clock {
    color: @highlight-color;
    display: flex;
  }

  .ticker {
      opacity: 1;
      animation-name: ticker;
      animation-duration: 1s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      transform: translate(0, -0.05em);
      display: inline-block;
      width: 0.4em;
      text-align: center;
  }
  
  @keyframes ticker {
    25% {
        opacity: 1;
    }
    
    100% {
      opacity: 0;
    }
  }
  </style>